<template>
  <q-menu
    ref="contextMenu"
    context-menu
    touch-position
    bordered
    side="right"
    overlay
  >
    <q-list>
      <template v-if="reportTableColumn.filterable">
        <template v-if="!reportElement.isFieldFiltered(reportTableColumn.field) || reportElement.isFieldExcludeFiltered(reportTableColumn.field)">
          <q-item
            v-close-popup
            clickable
            @click.stop="handleFilter(false)"
          >
            <q-item-section avatar>
              <q-icon name="filter_alt" />
            </q-item-section>
            <q-item-section>
              Filter to {{ labelForCell(cell) }}
            </q-item-section>
          </q-item>
          <q-separator />
          <q-item
            v-close-popup
            clickable
            @click.stop="handleFilter()"
          >
            <q-item-section avatar>
              <q-icon name="block" />
            </q-item-section>
            <q-item-section>
              Exclude {{ labelForCell(cell) }}
            </q-item-section>
          </q-item>
          <q-separator />
        </template>
        <q-item
          v-close-popup
          clickable
          @click.stop="$emit('edit-filter', reportTableColumn.field)"
        >
          <q-item-section avatar>
            <q-icon name="edit" />
          </q-item-section>
          <q-item-section>
            Edit Filters
          </q-item-section>
        </q-item>
        <q-separator />
        <q-item
          v-if="reportElement.isFieldFiltered(reportTableColumn.field)"
          v-close-popup
          clickable
          @click.stop="reportElement.resetFieldFilter(reportTableColumn.field); $emit('preview-changes')"
        >
          <q-item-section avatar>
            <q-icon name="clear" />
          </q-item-section>
          <q-item-section>
            Clear {{ reportTableColumn.label }} Filter
          </q-item-section>
        </q-item>
      </template>
      <template v-else-if="reportTableColumn.aggregate">
        <q-item
          v-close-popup
          clickable
          @click.stop="$emit('show-source', cell)"
        >
          <q-item-section avatar>
            <q-icon name="source" />
          </q-item-section>
          <q-item-section v-if="cell.row.row_count > 0">
            View Source ({{ cell.row.row_count }} rows)
            <q-tooltip v-if="reportElement.finalOptions.data_source_name">
              {{ reportElement.finalOptions.data_source_name }}
            </q-tooltip>
          </q-item-section>
          <q-item-section v-else>
            View Source
          </q-item-section>
        </q-item>
        <q-separator v-if="cell.row._url && cell.row.row_count" />
        <q-item
          v-if="cell.row._url && cell.row.row_count"
          v-close-popup
          clickable
          @click.stop="$emit('edit-model', cell)"
        >
          <q-item-section avatar>
            <q-icon name="edit" />
          </q-item-section>
          <q-item-section>
            Open Model
          </q-item-section>
        </q-item>
        <q-separator />
        <q-item
          v-close-popup
          clickable
          @click.stop="$emit('show-drill-down', cell)"
        >
          <q-item-section avatar>
            <q-icon name="zoom_in" />
          </q-item-section>
          <q-item-section>
            Drill Down
          </q-item-section>
        </q-item>
        <q-separator />
        <q-item
          v-close-popup
          clickable
          @click.stop="$emit('show-trend', cell)"
        >
          <q-item-section avatar>
            <q-icon name="show_chart" />
          </q-item-section>
          <q-item-section>
            See Trend
          </q-item-section>
        </q-item>
        <q-separator />
        <q-item
          v-close-popup
          clickable
          @click.stop="$emit('show-comparison', cell)"
        >
          <q-item-section avatar>
            <q-icon name="pie_chart" />
          </q-item-section>
          <q-item-section>
            Compare
          </q-item-section>
        </q-item>
      </template>
      <template v-else-if="cell.row && cell.row.data_source">
        <q-item
          v-close-popup
          clickable
          @click.stop="$emit('show-data-source', cell)"
        >
          <q-item-section avatar>
            <q-icon name="source" />
          </q-item-section>
          <q-item-section>
            View Source ({{ cell.row.data_source.row_count }} rows)
            <q-tooltip v-if="cell.row.data_source.name">
              {{ cell.row.data_source.name }}
            </q-tooltip>
          </q-item-section>
        </q-item>
      </template>
      <template v-else-if="cell.row._url">
        <q-item
          v-if="cell.row._url"
          v-close-popup
          clickable
          @click.stop="$emit('edit-model', cell)"
        >
          <q-item-section avatar>
            <q-icon name="edit" />
          </q-item-section>
          <q-item-section>
            Open Model
          </q-item-section>
        </q-item>
      </template>
    </q-list>
  </q-menu>
</template>

<script>
import { CELL_VALUE_OUTPUT_OPTIONS } from 'src/models/report/ReportElement'

export default {
  name: 'ReportTableCellMenu',
  props: {
    reportElement: {
      type: Object,
      required: true
    },
    reportTableColumn: {
      type: Object,
      required: true
    },
    cell: {
      type: Object,
      required: true
    },
    contextmenu: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  emits: ['edit-filter', 'preview-changes', 'show-source', 'edit-model', 'show-drill-down', 'show-trend', 'show-comparison', 'show-data-source'],
  methods: {
    show () {
      this.$refs.contextMenu.show(...arguments)
    },
    handleFilter (exclude = true) {
      const value = this.cell.value.hasValue ? this.cell.value.value : ''
      if (exclude) {
        this.reportElement.excludeFieldValue(this.reportTableColumn.field, value)
      } else {
        this.reportElement.filterToFieldValue(this.reportTableColumn.field, value)
      }
      this.$emit('preview-changes')
    },
    labelForCell (cell) {
      let label = (cell.value && (cell.value.value || cell.value.label)) || this.cellValueHandler(cell)
      if (label && label.value === false) {
        label = CELL_VALUE_OUTPUT_OPTIONS.FALSE
      } else if (label && label.value === true) {
        label = CELL_VALUE_OUTPUT_OPTIONS.TRUE
      }
      return label
    },
    cellValueHandler (cell) {
      if (!cell?.value?.value === false) {
        return cell.value
      }
      return CELL_VALUE_OUTPUT_OPTIONS.EMPTY
    }

  }
}
</script>
